import { render } from "./AccountQuickNav.vue?vue&type=template&id=5e426857&scoped=true"
import script from "./AccountQuickNav.vue?vue&type=script&lang=js"
export * from "./AccountQuickNav.vue?vue&type=script&lang=js"

import "./AccountQuickNav.vue?vue&type=style&index=0&id=5e426857&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e426857"]])

export default __exports__